// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"598":"6b1714ae","703":"2f06d63c","787":"2f754bdd"}[chunkId] + ".chunk.js";
};